import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import axios
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../assets/images/feautred-image1.jpg'; // Assuming your dynamic images will replace these
import config from '../../src/config';
import { useNavigate } from 'react-router-dom';
import { truncateText } from '../pages/Home';

export default function HomeRecentProject() {
    const navigate = useNavigate();
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 800,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ]
    };
    const [moreProjectsLoaded, setMoreProjectsLoaded] = useState(false);
    const [sliderProjects, setSliderProjects] = useState([]);

    const [projects, setProjects] = useState([]); // State for dynamic projects
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [categories, setCategories] = useState([])
    const [activeCategory, setActiveCategory] = useState('');
    const [projectChunks, setProjectChunks] = useState([]);

    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };

    const moveToProjects = () => {
        return navigate("/projects");
    }
    const fetchCategory = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/categories`, {
                withCredentials: true
            });
            console.log('response.data', response.data)
            const list = response?.data?.data || [];
            setCategories(list);
            // Auto-select first category and load its projects
            if (list.length > 0) {
                const firstName = list[0]?.name;
                setActiveCategory(firstName);
                handleCategoryClick(firstName);
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-projects`, {
                    withCredentials: true
                });
                setProjects(response.data); // Assuming the data structure has `projects` array
            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };
        fetchCategory()
        // fetchProjects();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleCategoryClick = async (name) => {
        try {
            setActiveCategory(name);
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-projects-by-category/${encodeURIComponent(name)}`, {
                withCredentials: true
            });
            const filtered = response.data || [];
            setProjects(filtered);
            setProjectChunks(chunkArray(filtered, 5));
            setSliderProjects(filtered.slice(0, 5));
            setMoreProjectsLoaded(filtered.length <= 5);
        } catch (error) {
            console.error('Error filtering projects by category:', error);
        }
    };
    return (
        <>
            {/* jkgfghkjfghkjf */}
            <div className="p-navigation-container p-justify-center">
                <div className='p-section-container text-center'><h2>Explore recent projects</h2>

                    <nav className="p-nav-bar">
                        {categories.map((tab, index) => (
                            <div key={tab.id} className="p-nav-item-wrapper">
                                <button
                                    className={`p-nav-item ${activeCategory === tab?.name ? 'active' : ''}`}
                                    // className={`p-nav-item `}

                                    onClick={() => handleCategoryClick(tab?.name)}
                                >
                                    {tab?.name}
                                </button>
                                {index < categories.length - 1 && <div className="p-nav-divider"></div>}
                            </div>
                        ))}
                    </nav>
                </div>
            </div>
            <div className='home-recent-project-main' data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                <div className='home-recent-projet-sec d-flex w-100 bg-white'>
                    {isMobile && <h6 className='text-uppercase mobile-title'>projects</h6>}
                    <div className='home-recent-projet-left d-flex flex-column'>
                        {projects.slice(0, 2).map((project, index) => (
                            <Link className='text-black' to={`/single-project/${project.slug}`}>
                                <div key={index} className='home-recent-project-item'>
                                    <div className='recent-featured-img'>
                                        <img src={`${config.BASE_URL}${project.featuredImage}`} alt={project.title} />
                                    </div>
                                    <div className='recent-project-detail d-flex'>
                                        <span className='project-name font-11 font-medium text-uppercase text-black'>{truncateText(project.title,20)}</span>
                                        <span className='project-scale font-11 text-black'>{project.location} · {project.space} sq ft</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                    <div className='home-recent-projet-center d-flex flex-column'>
                        {projects.slice(2, 3).map((project, index) => (
                            <Link className='text-black' to={`/single-project/${project.slug}`}>
                                <div key={index} className='home-recent-project-item'>
                                    <div className='recent-featured-img'>
                                        <img src={`${config.BASE_URL}${project.featuredImage}`} alt={project.title} />
                                    </div>
                                    <div className='recent-project-detail d-flex'>
                                        <span className='project-name font-14 font-medium text-uppercase text-black'>{project.title}</span>
                                        <span className='project-scale font-14 text-black'>{project.location} · {project.space} sq ft</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                    <div className='home-recent-projet-right d-flex flex-column'>
                        {projects.slice(3, 5).map((project, index) => (
                            <Link className='text-black' to={`/single-project/${project.slug}`}>
                                <div key={index} className='home-recent-project-item'>
                                    <div className='recent-featured-img'>
                                        <img src={`${config.BASE_URL}${project.featuredImage}`} alt={project.title} />
                                    </div>
                                    <div className='recent-project-detail d-flex'>
                                        <span className='project-name font-11 font-medium text-uppercase text-black'>{project.title}</span>
                                        <span className='project-scale font-11 text-black'>{project.location} · {project.space} sq ft</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className='home-recent-projet-slider bg-white filter-project-slider-mobile'>
                    <Slider {...sliderSettings}>
                        {projects.map((project, index) => (
                            <Link className='text-black' to={`/single-project/${project.slug}`}>
                                <div key={index} className='home-recent-project-item'>
                                    <div className='recent-featured-img'>
                                        <img src={`${config.BASE_URL}${project.featuredImage}`} alt={project.title} />
                                    </div>
                                    <div className='recent-project-detail d-flex'>
                                        <span className='project-name font-11 font-medium text-uppercase text-black'>{project.title}</span>
                                        <span className='project-scale font-11 text-black'>{project.location} · {project.size}</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </Slider>
                </div>
                <div className='view-all-project d-flex bg-white w-100'>
                    <div className='view-all-project-inner'>
                        <h2 className='text-black cursor-pointer-link' onClick={moveToProjects}>
                            {/* and more */}
                            +100 more
                            </h2>
                        <div className='view-all-desc text-black'>
                            <p>View all our design and build projects and get in touch with our team to begin yours. </p>
                            <Link to="/projects" className='more-text text-black font-12'>MORE</Link>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
